export const BASE_URL = "https://apis.automaticviral.co";